import React, { createContext, useContext, ReactNode } from 'react';
import {
  AdDetails,
  GetAdsResponse,
  GetPopularRequestsResponse,
} from '@/api/types/ads.types';
import { GetRootCategoriesResponse } from '@/api/types/categories.types';

interface ServerDataContextProps {
  initialAdDetails: AdDetails | null;
  initialPremiumAds: GetAdsResponse | null;
  popularRequests: GetPopularRequestsResponse | null;
  rootCategories: GetRootCategoriesResponse | null;
}

const ServerDataContext = createContext<ServerDataContextProps | undefined>(
  undefined
);

export const ServerDataProvider = ({
  children,
  adDetails,
  premiumAds,
  popularRequests,
  rootCategories,
}: {
  children: ReactNode;
  adDetails?: AdDetails | null;
  premiumAds?: GetAdsResponse | null;
  popularRequests?: GetPopularRequestsResponse | null;
  rootCategories?: GetRootCategoriesResponse | null;
}) => {
  return (
    <ServerDataContext.Provider
      value={{
        initialAdDetails: adDetails ?? null,
        initialPremiumAds: premiumAds ?? null,
        popularRequests: popularRequests ?? null,
        rootCategories: rootCategories ?? null,
      }}
    >
      {children}
    </ServerDataContext.Provider>
  );
};

export const useServerDataContext = () => {
  const context = useContext(ServerDataContext);
  if (!context) {
    throw new Error(
      'useServerDataContext must be used within ServerDataProvider'
    );
  }
  return context;
};
